// Copyright (c) 2026 WiseTime. All rights reserved.

import * as Sentry from "@sentry/react"
import { isProductionEnv } from "./app/config"

Sentry.init({
  dsn: "https://471a47c35a3153bb027f4148ee18ae92@o372558.ingest.us.sentry.io/4510899153731584",
  environment: isProductionEnv ? "production" : "staging",
  enabled: import.meta.env.MODE === "production",
  release: import.meta.env.VITE_GIT_REF,
  initialScope: {
    tags: { app: "timeline-frontend" },
  },
  // Disabled for GDPR compliance
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: false,
})
